import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { first } from 'rxjs';
import { ValveReleaseFilterService, ValveReleaseOption } from '../../services/valve-release-filter.service';

@Component({
  selector: 'app-valve-release-dropdown',
  templateUrl: './valve-release-dropdown.component.html',
  styleUrls: ['./valve-release-dropdown.component.scss'],
  standalone: false
})
export class ValveReleaseDropdownComponent implements OnInit, OnChanges {
  @Input() businessUnitId: string = '';
  @Input() applicationId: string = '';
  @Input() selectedReleaseId: string = '';

  @Output() selectedReleaseIdChange: EventEmitter<string> = new EventEmitter<string>();
  /** Emits the full selected option (or null) alongside the id, so callers can display its name. */
  @Output() selectedReleaseChange: EventEmitter<ValveReleaseOption | null> = new EventEmitter<ValveReleaseOption | null>();

  releases: ValveReleaseOption[] = [];
  searchText: string = '';
  isLoading: boolean = false;

  constructor(private readonly valveReleaseFilterService: ValveReleaseFilterService) {}

  get filteredReleases(): ValveReleaseOption[] {
    const query: string = this.searchText.toLowerCase();

    if (!query) {
      return this.releases;
    }

    return this.releases.filter((release: ValveReleaseOption) => release.name.toLowerCase().includes(query));
  }

  ngOnInit(): void {
    this.loadReleases();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['businessUnitId'] || changes['applicationId']) {
      this.loadReleases();
    }
  }

  onSelectedReleaseChange(releaseId: string): void {
    this.selectedReleaseIdChange.emit(releaseId);
    this.selectedReleaseChange.emit(this.releases.find((release: ValveReleaseOption) => release.id === releaseId) ?? null);
  }

  private loadReleases(): void {
    this.isLoading = true;

    this.valveReleaseFilterService
      .getValveReleases(this.businessUnitId, this.applicationId)
      .pipe(first())
      .subscribe({
        next: (releases: ValveReleaseOption[]) => {
          this.releases = releases;
          this.isLoading = false;

          const selectedReleaseStillExists: boolean = this.releases.some((release: ValveReleaseOption) => release.id === this.selectedReleaseId);
          if (!selectedReleaseStillExists) {
            this.selectedReleaseId = '';
            this.selectedReleaseIdChange.emit('');
            this.selectedReleaseChange.emit(null);
          }
        },
        error: () => {
          this.releases = [];
          this.isLoading = false;
          this.selectedReleaseId = '';
          this.selectedReleaseIdChange.emit('');
          this.selectedReleaseChange.emit(null);
        }
      });
  }
}
